"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

exports.__esModule = true;
exports.escapeHtml = escapeHtml;
exports.escapeScript = escapeScript;
exports.htmlOpen = htmlOpen;
exports.htmlClose = htmlClose;
exports.wrapHtml = wrapHtml;
exports.wrapStyle = wrapStyle;

function escapeHtml(html) {
  return html.replace(/[&<"]/g, function (m) {
    return {
      '&': '&amp;',
      '<': '&lt;',
      '"': '&quot;'
    }[m];
  });
}

function escapeScript(content) {
  return content.replace(/<(\/script>)/g, '\\x3c$2');
}

function htmlOpen(tagName, attrs) {
  var attrStr = attrs ? Object.entries(attrs).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (value == null || value === false) return;
    key = " ".concat(escapeHtml(key));
    if (value === true) return key;
    return "".concat(key, "=\"").concat(escapeHtml(value), "\"");
  }).filter(Boolean).join('') : '';
  return "<".concat(tagName).concat(attrStr, ">");
}

function htmlClose(tagName) {
  return "</".concat(tagName, ">");
}

function wrapHtml(tagName, content, attrs) {
  if (content == null) return htmlOpen(tagName, attrs);
  return htmlOpen(tagName, attrs) + (content || '') + htmlClose(tagName);
}

function wrapStyle(text, style) {
  if (style.code) text = wrapHtml('code', text);
  if (style.del) text = wrapHtml('del', text);
  if (style.em) text = wrapHtml('em', text);
  if (style.strong) text = wrapHtml('strong', text);
  return text;
}